import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Select, Input, Button, notification } from 'antd';
import InviteViaTextWrapper from './styles/invite-via-text.style';
import PhoneInput from 'react-phone-input-2';
import * as TherapistActions from '../../actions/therapist';
import 'react-phone-input-2/lib/style.css';
import { baseChatURL } from '../../constants/global';

const { Option } = Select;

class InviteViaTexModal extends Component {
    constructor(props){
        super(props);
        this.state={
            phone: "",
            showVisitOverview: true
        }
        this.sendTextMessage = this.sendTextMessage.bind(this);
    }

    sendTextMessage(){
        const { dispatch, setting, therapistRoom } = this.props;
        const { currentUser } = setting;
        
        if(this.state.phone.trim().length < 7){
            notification['error']({
                message: 'Error',
                description: 'Please enter the phone number',
            });
            return;
        }
        
        const data = {
            mobile: this.state.phone,
            message: "Hello, this is " + (currentUser.firstName + " " + currentUser.lastName) + ". Please join me for a secure video call at:\n" + (baseChatURL+"/videoroom/"+therapistRoom)
        }
        dispatch(TherapistActions.sendTextMessage(data));
        this.props.onCancel();
    }
    render() {
		const { setting, therapistRoom } = this.props;
        const { currentUser } = setting;

        return (
            
                <Modal
                        width={445}
                        className="inviteModal"
                        overlayClassName="inviteModal1"
                        visible={this.props.visible}
                        footer=""
                        style={{ zIndex: 2000 }}
                        onCancel={this.props.onCancel}
                        >
                            <InviteViaTextWrapper>
                         <div className="invite-form-wrapper">
                             <header>
                             <h1>Invite via Text Message</h1>    
                             </header>
                             <div className="invite-form-content">
                             <Form colon={false}>
                                    <div className="list-item">
                                        <Form.Item  className="textLabel" label="Patient/Caregiver Phone Number">
                                            <PhoneInput className="textBoxPhone"
                                                        country={'us'}
                                                        value={this.state.phone}
                                                        onChange={phone => this.setState({ phone })}
                                                        />
                                        </Form.Item>
                                    </div>
                                    <div className="list-item">
                                        <Form.Item className="textLabel" label="message">
                                        <p>{"Hello, this is " + (currentUser.firstName + " " + currentUser.lastName) + ". Please join me for a secure video call at:\n" + (baseChatURL+"/videoroom/"+therapistRoom)} </p>
                                        </Form.Item>
                                    </div>
                                   
                                    <div className="list-item action-pan">
                                      <Button type="primary" className="sendBtn" onClick={this.sendTextMessage}>Send Text Message</Button>
                                    </div> 
                            </Form>
                             </div>
                         </div>
                          </InviteViaTextWrapper>
                 </Modal>
                     
        );
    }
}

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps)(InviteViaTexModal);
